import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { Typography, Menu, Row, Col, Button, Drawer, Avatar } from "antd";
import { SettingOutlined, UserOutlined } from "@ant-design/icons";


/* Global State*/ 


import { useTranslation } from "react-i18next";

const { Paragraph } = Typography;
let globalState = undefined;

const FC = ({ isShow, history, onClose, onLogOut }) => {
  
  const { t, i18n } = useTranslation();
  const closeMenu = () => {
    onClose();
  };

  const selectedMenuKey = useMemo(() => {
    let key;
    if (window.location.pathname == "/orderWatcher/dashboard/recentOrder") {
      key = "recent_order";
    }

    if (window.location.pathname == "/orderWatcher/dashboard/report") {
      key = "report";
    }
    return key;
  }, [window.location.pathname]);

  return (
    <Drawer
      placement="right"
      width={300}
      onClose={() => {
        closeMenu();
      }}
      closable={false}
      open={isShow}
    >
      <Row justify="start" align="middle">
        <Col span={6}>
          <Avatar size={48} icon={<UserOutlined />} />
        </Col>
        <Col span={18} style={{ fontSize: 22 }}>
          <Paragraph
            style={{
              width: "100%",
              textAlign: "center",
              margin: 0,
            }}
            ellipsis={{
              rows: 2,
            }}
          >
            {globalState.user?.name}
          </Paragraph>
        </Col>
      </Row>

      <Row>
        <Button
          type="primary"
          size="large"
          style={{ width: "100%", fontSize: 18, marginTop: 20, marginBottom: 20 }}
          onClick={() => {
            onLogOut();
          }}
        >
          登出
        </Button>
      </Row>

      <Menu selectedKeys={[selectedMenuKey]} defaultOpenKeys={["recent_order"]}>
        <Menu.Item
          onClick={() => {
            closeMenu();

            if (selectedMenuKey == "recent_order") {
              //
            } else {
              history.push("/orderWatcher/dashboard/recentOrder");
            }
          }}
          key="recent_order"
          icon={<SettingOutlined style={{ fontSize: 22 }} />}
          style={{ fontSize: 26 }}
        >
          今日訂單
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            closeMenu();

            if (selectedMenuKey == "report") {
              //
            } else {
              history.push("/orderWatcher/dashboard/report");
            }
          }}
          key="report"
          icon={<SettingOutlined style={{ fontSize: 22 }} />}
          style={{ fontSize: 26 }}
        >
          報告
        </Menu.Item>
      </Menu>
    </Drawer>
  );
};

export default FC;
